import { h, Fragment } from 'preact';
import { Text } from 'preact-i18n';
import util from 'preact-util';

import DentalChart from './dentalChart';
import { animalAge } from '../../lib/animalAge';

// Standalone tannkart printout (TICKET-01561). Rendered off-screen by
// DentalChartSection and handed to printViaIframe, the same way journalPrint.js
// is printed from viewJournal/newJournal. Deliberately a pure presentational
// component with no store access so it stays importable under jest: the
// section resolves customer/owner/animal/logo and passes them in.
//
// Works with zero findings on purpose: a clinic can print a blank dog/cat chart
// to note on by hand (the read-only DentalChart renders every tooth regardless).

function ownerName(owner) {
    if (!owner) return '';
    const { firstname = '', lastname = '', name = '' } = owner;
    const full = `${firstname.trim()} ${lastname.trim()}`.trim();
    return full || name.trim();
}

function DentalChartPrint(props) {
    const {
        customer = {},
        owner,
        animal = {},
        findings = [],
        logoSrc,
        date = new Date(),
    } = props;

    const hasFindings = findings.length > 0;

    return (
        <div class='receipt'>
            <div class='container receipt'>
                <div class='row'>
                    <div class='col-4 text-center d-flex align-items-center'>
                        {logoSrc && <img src={logoSrc} class='img-fluid' />}
                    </div>
                    <div class='col-8 d-flex align-items-center'>
                        <h3>{customer.name}</h3>
                    </div>
                </div>
                <div class='row mt-3'>
                    <div class='col-12 d-flex flex-column align-items-end'>
                        <div class='d-flex flex-row'>
                            <Text id='dyrejournal.date'>Date:</Text> {util.formatDate(date, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}
                        </div>
                    </div>
                </div>

                <hr />

                <div class='row'>
                    <div class='col-12'>
                        {owner && (
                            <div class='w-100 px-3 py-2 mt-2 d-flex flex-row bg-lightmode rounded-lg'>
                                <div class='w-20 font-weight-bold'>
                                    <Text id='dyrejournal.animal-owner'>Owner</Text>
                                </div>
                                <div class='w-80 d-flex flex-column justify-content-start ms-3 flex-fill'>
                                    <div>{ownerName(owner)}</div>
                                    {owner.address && <div>{owner.address}</div>}
                                    {(owner.postalcode || owner.place) && <div>{owner.postalcode} {owner.place}</div>}
                                    {owner.cellphone && <div>{owner.cellphone}</div>}
                                </div>
                            </div>
                        )}

                        <div class='w-100 px-3 py-2 mt-3 d-flex flex-row bg-lightmode rounded-lg'>
                            <div class='w-20 font-weight-bold'>
                                <Text id='dyrejournal.animal-title'>Animal</Text>
                            </div>
                            <div class='w-80 d-flex flex-column justify-content-start ms-3 flex-fill'>
                                <div>
                                    {animal.pedigreeName ? `${animal.pedigreeName}${animal.name ? ` (${animal.name})` : ''}` : animal.name}
                                    {animal.species && <>, {animal.species}</>}
                                    {animal.breed && <>, {animal.breed}</>}
                                    {animal.birth && <>, f.{util.formatDate(animal.birth, { locale: 'nb-NO' })} ({animalAge(animal.birth)})</>}
                                </div>
                                {animal.chipId && <div>ChipID: {animal.chipId}</div>}
                            </div>
                        </div>

                        <div class='w-100 px-3 py-2 mt-3 d-flex flex-column'>
                            <div class='w-100 font-weight-bold mb-2'>
                                <i class='fa-duotone fa-tooth me-2' />
                                <Text id='dental.sectionTitle'>Dental Chart</Text>
                            </div>
                            {!hasFindings && (
                                <div class='dental-print-no-findings small mb-2'>
                                    <Text id='dental.printNoFindings'>No dental findings recorded. Use the chart below to note findings.</Text>
                                </div>
                            )}
                            <div class='w-100'>
                                <DentalChart
                                    species={animal.species}
                                    speciesId={animal.speciesId}
                                    findings={findings}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DentalChartPrint;
